'kiwi public';

import _construct from "@babel/runtime-corejs3/helpers/esm/construct";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/ends-with";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _ from 'lodash';
import Vue from 'vue';
import Logger from '@/libs/Logger';
var log = Logger.namespace('ThemeManager');
var createdInstance = null;
var ThemeManager = /*#__PURE__*/function () {
  function ThemeManager(state, argTheme) {
    _classCallCheck(this, ThemeManager);
    this.state = state;
    this.activeTheme = null;
    this.previousTheme = null;
    this.varsElement = null;
    this.currentElement = null;
    this.loadingElement = null;
    this.renderingMode = null;
    Vue.observable(this);
    var initialTheme = this.findTheme(argTheme) || this.findTheme(state.setting('theme')) || this.availableThemes()[0];
    this.setTheme(initialTheme);
  }
  return _createClass(ThemeManager, [{
    key: "availableThemes",
    value: function availableThemes() {
      var themes = this.state.getSetting('settings.themes');

      // Add new-style themes if they're not already in the list
      var newStyleThemes = [{
        name: 'Default',
        isNewStyle: true
      }, {
        name: 'RelayOS',
        isNewStyle: true
      }];
      newStyleThemes.forEach(function (newTheme) {
        var exists = _findInstanceProperty(_).call(_, themes, function (t) {
          return t.name.toLowerCase() === newTheme.name.toLowerCase();
        });
        if (!exists) {
          themes.push(newTheme);
        } else if (!exists.isNewStyle) {
          // Update existing theme to use new style
          exists.isNewStyle = true;
        }
      });
      log.debug('Available themes:', themes);
      return themes;
    }
  }, {
    key: "findTheme",
    value: function findTheme(name) {
      if (!name) {
        return null;
      }
      log.debug('Finding theme:', name);
      var theme = _findInstanceProperty(_).call(_, this.availableThemes(), function (t) {
        return t.name.toLowerCase() === name.toLowerCase();
      });
      log.debug('Found theme:', theme);
      return theme;
    }
  }, {
    key: "setRenderingMode",
    value: function setRenderingMode(mode) {
      if (this.renderingMode === mode) {
        return;
      }
      this.renderingMode = mode;
      log.debug('Setting rendering mode:', mode);

      // Reload the theme to apply the rendering mode
      this.reload();
    }
  }, {
    key: "currentTheme",
    value: function currentTheme() {
      var theme = this.activeTheme || this.availableThemes()[0];
      return this.findTheme(theme.name);
    }
  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      var _this = this;
      var nextTheme = _Object$assign(Object.create(null), typeof theme === 'string' ? this.findTheme(theme) : theme);
      if (!nextTheme) {
        // Tried to set an invalid theme, abort
        // reset the theme setting name to current if its not valid
        if (this.activeTheme && this.activeTheme.name !== this.state.setting('theme')) {
          this.state.setting('theme', this.activeTheme.name);
        }
        log.error('Invalid theme', nextTheme);
        return;
      }

      // For new-style themes, we don't need a URL
      if (!nextTheme.isNewStyle && !nextTheme.url) {
        // Tried to set an invalid legacy theme, abort
        if (this.activeTheme && this.activeTheme.name !== this.state.setting('theme')) {
          this.state.setting('theme', this.activeTheme.name);
        }
        log.error('Invalid legacy theme (missing URL)', nextTheme);
        return;
      }
      if (this.loadingElement) {
        // There is already a loading theme
        // remove it as we are about to load another
        document.head.removeChild(this.loadingElement);
        this.loadingElement = null;
      }
      if (this.activeTheme && this.activeTheme.name === nextTheme.name) {
        // Theme did not change, abort
        return;
      }
      var nextNameLower = nextTheme.name.toLowerCase();
      var themeElement = document.createElement('link');
      if (this.previousTheme) {
        // If previousTheme is not set then this is the initial theme
        // do not check its loading/error state so there is always an
        // active and previous theme set
        themeElement.onload = function () {
          // New theme loaded successfully
          _this.previousTheme = _this.activeTheme;
          _this.activeTheme = nextTheme;
          if (_this.currentElement) {
            // Remove the old theme from the DOM
            document.head.removeChild(_this.currentElement);
          }

          // Move our loaded element into current position
          _this.currentElement = _this.loadingElement;
          _this.loadingElement = null;
          if (nextTheme.name !== _this.state.setting('theme')) {
            // Reset the theme setting name to current if its not valid
            _this.state.setting('theme', nextTheme.name);
          }
          _this.state.$emit('theme.change', nextTheme, _this.previousTheme);

          // If we have a rendering mode, load it now
          if (_this.renderingMode) {
            _this.loadRenderingMode(_this.renderingMode);
          }
        };
        themeElement.onerror = function () {
          // New theme failed to load, remove its loading element
          document.head.removeChild(_this.loadingElement);
          _this.loadingElement = null;
          if (nextNameLower === 'custom' && !nextTheme.isNewStyle && !/\/theme\.css(\?|$)/.test(nextTheme.url)) {
            // For custom themes try appending /theme.css
            _this.setCustomThemeUrl(ThemeManager.themeUrl(nextTheme));
            return;
          }
          _this.state.$emit('theme.failed', nextTheme, _this.activeTheme);
        };
        this.loadingElement = themeElement;
      } else {
        // This is our initial theme set by url param or config
        this.activeTheme = nextTheme;
        this.previousTheme = nextTheme;
        this.currentElement = themeElement;
      }
      themeElement.rel = 'stylesheet';
      themeElement.type = 'text/css';
      if (nextTheme.isNewStyle) {
        themeElement.href = ThemeManager.themeUrl(nextTheme);
      } else if (nextNameLower !== 'custom') {
        themeElement.href = ThemeManager.themeUrl(nextTheme);
      } else {
        themeElement.href = nextTheme.url;
      }
      document.head.appendChild(themeElement);
    }
  }, {
    key: "loadRenderingMode",
    value: function loadRenderingMode(mode) {
      // Remove any existing rendering mode stylesheet
      var existingElement = document.getElementById('rendering-mode-stylesheet');
      if (existingElement) {
        document.head.removeChild(existingElement);
      }

      // Create a new link element for the rendering mode
      var renderingModeElement = document.createElement('link');
      renderingModeElement.rel = 'stylesheet';
      renderingModeElement.type = 'text/css';
      renderingModeElement.id = 'rendering-mode-stylesheet';
      renderingModeElement.href = ThemeManager.renderingModeUrl(mode);
      renderingModeElement.onload = function () {
        log.debug("Rendering mode ".concat(mode, " loaded successfully"));
      };
      renderingModeElement.onerror = function () {
        log.error("Failed to load rendering mode ".concat(mode));
      };
      document.head.appendChild(renderingModeElement);
    }
  }, {
    key: "setCustomThemeUrl",
    value: function setCustomThemeUrl(url) {
      var theme = this.findTheme('custom');
      if (!theme) {
        return;
      }
      theme.url = url;
      this.setTheme(theme);
    }
  }, {
    key: "reload",
    value: function reload() {
      var theme = this.currentTheme();
      if (!theme) {
        return;
      }
      if (theme.isNewStyle) {
        // For new-style themes, just re-apply the theme
        this.setTheme(theme.name);
        return;
      }

      // Legacy theme URL handling
      var url = theme.url;
      if (url.indexOf('cb=') > -1) {
        url = url.replace(/cb=[0-9]+/, function () {
          return 'cb=' + Date.now();
        });
      } else if (url.indexOf('?') > -1) {
        url += '&cb=' + Date.now();
      } else {
        url += '?cb=' + Date.now();
      }
      theme.url = url;
      this.setTheme(theme.name);
    }
  }, {
    key: "themeVar",
    value: function themeVar(varName) {
      var _context;
      if (!this.varsElement) {
        this.varsElement = document.querySelector('.kiwi-wrap');
      }
      var styles = window.getComputedStyle(this.varsElement);
      var value = styles.getPropertyValue('--kiwi-' + varName);
      return _trimInstanceProperty(_context = value || '').call(_context);
    }
  }], [{
    key: "themeUrl",
    value: function themeUrl(theme) {
      // Check if this is a new-style theme from the styles directory
      if (theme.isNewStyle) {
        var _context2;
        // Determine the base path for static resources
        // Get the full path without the hostname and protocol
        var fullPath = window.location.pathname;
        // Remove trailing slash if present
        var normalizedPath = _endsWithInstanceProperty(fullPath).call(fullPath, '/') ? _sliceInstanceProperty(fullPath).call(fullPath, 0, -1) : fullPath;

        // Extract the application root path (e.g., /relayos-kiwiirc/)
        var baseUrl = '/';

        // Check if we're in a path that starts with /relayos-kiwiirc/
        if (_includesInstanceProperty(normalizedPath).call(normalizedPath, '/relayos-kiwiirc')) {
          baseUrl = '/relayos-kiwiirc/';
        } else {
          // For other cases, extract the first path segment
          var pathParts = normalizedPath.split('/');
          if (pathParts.length > 1 && pathParts[1]) {
            baseUrl = '/' + pathParts[1] + '/';
          }
        }
        return _concatInstanceProperty(_context2 = "".concat(baseUrl, "styles/themes/")).call(_context2, theme.name.toLowerCase(), "/theme.css");
      }

      // Legacy theme URL handling
      var _theme$url$split = theme.url.split('?'),
        _theme$url$split2 = _slicedToArray(_theme$url$split, 2),
        url = _theme$url$split2[0],
        qs = _theme$url$split2[1];
      if (url[url.length - 1] !== '/') {
        url += '/';
      }
      return url + 'theme.css' + (qs ? '?' + qs : '');
    }
  }, {
    key: "renderingModeUrl",
    value: function renderingModeUrl(mode) {
      var _context3;
      // Determine the base path for static resources
      // Get the full path without the hostname and protocol
      var fullPath = window.location.pathname;
      // Remove trailing slash if present
      var normalizedPath = _endsWithInstanceProperty(fullPath).call(fullPath, '/') ? _sliceInstanceProperty(fullPath).call(fullPath, 0, -1) : fullPath;

      // Extract the application root path (e.g., /relayos-kiwiirc/)
      var baseUrl = '/';

      // Check if we're in a path that starts with /relayos-kiwiirc/
      if (_includesInstanceProperty(normalizedPath).call(normalizedPath, '/relayos-kiwiirc')) {
        baseUrl = '/relayos-kiwiirc/';
      } else {
        // For other cases, extract the first path segment
        var pathParts = normalizedPath.split('/');
        if (pathParts.length > 1 && pathParts[1]) {
          baseUrl = '/' + pathParts[1] + '/';
        }
      }
      return _concatInstanceProperty(_context3 = "".concat(baseUrl, "styles/render-modes/")).call(_context3, mode, ".css");
    }
  }]);
}();
export { ThemeManager as default };
ThemeManager.instance = function () {
  if (!createdInstance) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    createdInstance = _construct(ThemeManager, args);
  }
  return createdInstance;
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ThemeManager"]
window._kiwi_exports.libs.ThemeManager = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
